export default {
    BAR : 'bar'
}